import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import invitado from './reducers/invitado.reducer.js'
import vehicleReducer from './reducers/vehicle.reducer.js'

const reducers = combineReducers({
  invitado,
  vehicle: vehicleReducer,
})

const store = createStore(reducers, {}, applyMiddleware(thunk))

export default store